import {
    styled,
    Typography,
    IconButton,
} from "@mui/material"

import { SIDEBAR_SPACING, SIDEBAR_SPACING_MOBILE } from "../../constants/layout"
import { styledForMobile } from "../../utils/styledForMobile"

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
}))

export const ContentHeader = styledForMobile("div", ["hasBottomComponent"])(({ hasBottomComponent, theme, isMobile }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: isMobile ? theme.spacing(0, SIDEBAR_SPACING_MOBILE, hasBottomComponent ? 1 : SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE)
        : theme.spacing(0, SIDEBAR_SPACING, hasBottomComponent ? 1 : 0, SIDEBAR_SPACING),
    paddingTop: isMobile && 0,
}))

export const TitleContainer = styled("div")({
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    width: "100%",
})

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
    lineHeight: "34px",
    flexGrow: 1,
}))

export const Button = styled(IconButton)(({ theme }) => ({
    minWidth: "unset",
    marginRight: theme.spacing(4),
    padding: theme.spacing(1),
    textTransform: "initial",
    width: "fit-content",
}))

export const TitleSideComponent = styled("div")(({ theme }) => ({
    marginLeft: theme.spacing(9),
    marginRight: 0,
}))

export const ContentScrollContainer = styled("div")(({ allowScroll }) => ({
    display: "flex",
    height: "100%",
    overflow: allowScroll ? "auto" : "hidden",
    width: "100%",
}))

export const ContentContainer = styled("div")(() => ({
    width: "100%",
}))